export const dashboardTableSx = {
    boxShadow: 'none',
    fontFamily: 'inherit',
    fontSize: '1rem',
    lineHeight: 1.5,
    '& .MuiTableHead-root .MuiTableCell-root': {
        color: 'rgba(0, 0, 0, 0.6) !important',
        fontSize: '0.75rem !important',
        fontWeight: 700,
        textTransform: 'uppercase',
        borderTop: 0,
        borderRight: 0,
        borderBottom: '2px solid',
        borderLeft: 0,
        borderColor: 'divider',
        fontFamily: 'inherit',
        lineHeight: '1.5 !important',
        padding: '0 8px !important',
    },
    '& .MuiTableBody-root .MuiTableCell-root': {
        fontFamily: 'inherit',
        fontSize: '1rem',
        lineHeight: 1.5,
        padding: '8px 4px',
        borderColor: 'divider',
    },
    '& .MuiTableBody-root .MuiTableRow-root:not(:last-child) .MuiTableCell-root:first-of-type': {
        color: 'primary.main',
        fontWeight: 500,
    },
    '& .MuiTableBody-root .MuiTableRow-root:not(:last-child):hover': {
        backgroundColor: 'rgba(25, 118, 210, 0.08)',
    },
    '& .MuiTableBody-root .MuiTableRow-root:last-child': {
        backgroundColor: 'rgba(49, 130, 189, 0.08)',
        borderTop: '2px solid',
        borderColor: 'primary.main',
    },
    '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
        fontWeight: 700,
        paddingTop: '12px',
        paddingBottom: '12px',
    },
};
